import Api from "../Utils/Axios";

export const GetAppVersion = async () => {
  try {
    const response = await Api.get("setting/appVersion");
    return response;
  } catch (error) {
    console.error("error: ", error);
  }
};

export const UpdateVersion = async (data) => {
  const response = await Api.put("setting/appVersion", data);
  return response.data;
}

export const GetUserMessage = async (name) => {
  const response = await Api.get('setting/userMessage', { params: { name } });
  return response;
};

export const UpdateUserMessage = async (data) => {
  const { name, message } = data || {};
  const response = await Api.put(
    'setting/userMessage',
    { message },
    { params: { name } }
  );
  return response.data;
}

export const GetFreeChatLimit = async () => {
  const response = await Api.get('setting/openAIChatMessageLimit');
  return response.data;
};

export const UpdateFreeChatLimit = async (data) => {
  const response = await Api.put('setting/openAIChatMessageLimit', data);
  return response.data.message;
}